import { useMutation } from "@apollo/client";
import { useMsal } from "@azure/msal-react";
import { useState } from "react";

import { loginRequest } from "../../msalConfig";
import { O_AUTH_LOGIN } from "../../queries/user";
import { getNotification } from "../../utils";
import { callMsGraph } from "../../utils/MSGraph";
import { trackClarityEvent } from "../../utils/telemetry";

const useAuthentication = (updateUserAndToken) => {
  const [loading, setLoading] = useState(false);

  const { instance: msalInstance } = useMsal();
  const [oAuthLogin] = useMutation(O_AUTH_LOGIN);

  const handleLogin = async () => {
    try {
      setLoading(true);
      await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      const notificationData = getNotification(error);

      console.error(notificationData);
      trackClarityEvent("admin_login_error", {
        message: notificationData,
      });
      setLoading(false);
    }
  };

  const completeLogin = async (msalResponse) => {
    try {
      setLoading(true);

      const { accessToken } = msalResponse;
      const userData = await callMsGraph(accessToken);
      const { displayName: name, mail: email } = userData;

      const { data } = await oAuthLogin({
        variables: { name, email: email.toLowerCase(), accessToken },
        notifyOnNetworkStatusChange: true,
      });

      const { user, token } = data.oAuthLogin;

      updateUserAndToken({ user, token });
      trackClarityEvent("admin_login_success", {
        email,
        userId: user.id,
      });

      return token;
    } catch (error) {
      const notificationData = getNotification(error);

      console.error(notificationData);
      trackClarityEvent("admin_login_error", {
        message: notificationData,
      });

      return null;
    } finally {
      setLoading(false);
    }
  };

  return { handleLogin, completeLogin, msalInstance, loading };
};

export default useAuthentication;
